export default __webpack_public_path__ + "static/media/Schools_Organisations_List_Template.ce133b67.xlsx";